// src/components/Clientes.js
import React from "react";
import "./Clientes.css";

// Importe as fotos dos clientes - use fotos reais aqui
import cliente1 from "../assets/Clientes/cliente1.jpg";
import cliente11 from "../assets/Clientes/cliente1-1.jpg";
import cliente2 from "../assets/Clientes/cliente2.jpg";
import cliente22 from "../assets/Clientes/cliente2-2.jpg";
import cliente3 from "../assets/Clientes/cliente3.jpg";
import cliente33 from "../assets/Clientes/cliente3-3.jpg";
import cliente4 from "../assets/Clientes/cliente4.jpg";
import cliente44 from "../assets/Clientes/cliente4-4.jpg";
import cliente5 from "../assets/Clientes/cliente5.cr2";
import cliente55 from "../assets/Clientes/cliente5-5.cr2";

const Clientes = () => {
  const images = [
    cliente1,
    cliente2,
    cliente3,
    cliente4,
    cliente5,
    cliente11,
    cliente22,
    cliente33,
    cliente44,
    cliente55,
  ];
  const allImages = [...images, ...images]; // Duplicamos para o efeito de loop contínuo

  return (
    <section className="clientes-section">
      <div className="clientes-scroller">
        <div className="scroller-inner">
          {allImages.map((image, index) => (
            <div className="client-logo" key={index}>
              <img src={image} alt={`Cliente ${index + 1}`} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Clientes;
